import React from "react";
import { FormattedDate, FormattedTime } from "react-intl";

const FormattedDateTime = ({ value }: { value: string }) => {
    const date = new Date(value);
    return <><FormattedDate value={date} /> <FormattedTime value={date} /></>
}

export default FormattedDateTime;